import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "26",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m10.6 16.6-3.69 3.736c-.515.522-.772.782-.994.8a.6.6 0 0 1-.505-.207c-.144-.168-.144-.535-.144-1.267V17.79c0-.657-.539-1.133-1.189-1.228v0a3.6 3.6 0 0 1-3.04-3.04C1 13.262 1 12.952 1 12.333V6.76c0-2.016 0-3.024.392-3.794a3.6 3.6 0 0 1 1.574-1.574C3.736 1 4.744 1 6.76 1h8.88c2.016 0 3.024 0 3.794.392a3.6 3.6 0 0 1 1.574 1.574c.392.77.392 1.778.392 3.794v5.04m0 13.2-2.612-1.816c-.367-.255-.55-.383-.75-.473a2.4 2.4 0 0 0-.555-.174c-.216-.04-.44-.04-.887-.04H14.44c-1.344 0-2.016 0-2.53-.261a2.4 2.4 0 0 1-1.048-1.05c-.262-.513-.262-1.185-.262-2.529V15.64c0-1.344 0-2.016.262-2.53a2.4 2.4 0 0 1 1.048-1.048c.514-.262 1.186-.262 2.53-.262h6.72c1.344 0 2.016 0 2.53.262a2.4 2.4 0 0 1 1.048 1.048c.262.514.262 1.186.262 2.53v3.257c0 1.118 0 1.678-.183 2.119a2.4 2.4 0 0 1-1.299 1.299c-.44.182-1 .182-2.118.182V25Z"
    }, null, -1)
  ])))
}
export default { render: render }